export type AccountingPrintSettings = {
  companyName: string;
  logoDataUrl: string;
  showQr: boolean;
  qrText: string;
  watermarkEnabled: boolean;
  watermarkText: string;
  pageOrientation: 'portrait' | 'landscape';
};

const KEY = 'accounting_print_settings_v1';

const DEFAULTS: AccountingPrintSettings = {
  companyName: 'کاخ سازان داروگ',
  logoDataUrl: '',
  showQr: true,
  qrText: 'Darvag Project Manager - Accounting',
  watermarkEnabled: true,
  watermarkText: 'نسخه چاپی / تاریخ دریافت:',
  pageOrientation: 'portrait',
};

export function getAccountingPrintSettings(): AccountingPrintSettings {
  if (typeof window === 'undefined') return DEFAULTS;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<AccountingPrintSettings>) };
  } catch {
    return DEFAULTS;
  }
}

export function saveAccountingPrintSettings(value: AccountingPrintSettings): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KEY, JSON.stringify(value));
}
